export const enum LoadingState {
  Loading,
  Error,
  Done,
}
